export const environment = {
    production: true,
    baseUrl: 'https://apdeb-api-pre.cashme.it',
    apiBasePath: '/api/c'
};
